import { Directive, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmDialogService } from '@ird/ng-base';
import { TranslateService } from '@ngx-translate/core';
import { ImpersonationService, LoginService, UserService } from '../services';

@Directive({
  selector: '[sharedImpersonate]',
})
export class ImpersonateDirective {
  @Input() username: string;

  constructor(
    private confirmDialogService: ConfirmDialogService,
    private translateService: TranslateService,
    private loginService: LoginService,
    private router: Router,
    private userService: UserService,
    private impersonationService: ImpersonationService,
  ) {}

  @HostListener('click') onClick() {
    this.confirmDialogService
      .openConfirmDialog(
        this.translateService.instant('ADMINISTRATION.USERS.IMPERSONATE_CONTENT', {
          username: this.username,
        }),
        'ADMINISTRATION.USERS.IMPERSONATE_TITLE',
      )
      .subscribe((confirmationResult) => {
        if (confirmationResult.confirmed) {
          this.loginService.getImpersonatedToken(this.username).subscribe((token) => {
            this.impersonationService.start(token);
            this.userService.initUser().then(() => {
              this.router.navigate(['/']);
            });
          });
        }
      });
  }
}
